import React from 'react'

export default function Events() {
    return (
        <div>
            <h1>Hello from Events Component</h1>
        </div>
    )
}